import { handleActions } from 'redux-actions';
import { Actions, saveScheduleSuccess } from 'actions/scheduleActions';
import { Actions as BuildingActions, getBuildingSuccess } from 'actions/buildingActions';
import { Actions as ThemeActions, scheduleThemeSuccess } from 'actions/themeActions';
import { merge, omit } from 'lodash';
import { DeviceId, Schedule } from 'shared/models';


export type State = {
    data: Record<DeviceId, Schedule>;
};

export const initialState = Object.freeze<State>({
    data: {},
});

function addSchedules(state: State, schedules: Record<DeviceId, Schedule>) {
    const untouchedData = omit(state.data, Object.keys(schedules));
    return {
        ...state,
        data: merge({}, untouchedData, schedules),
    };
}

export const schedulesReducer = handleActions({
    [Actions.SAVE_SCHEDULE_SUCCESS]: (state: State, action: ReturnType<typeof saveScheduleSuccess>) => {
        const schedule = action.payload;
        const { deviceId } = action.meta;
        return addSchedules(state, { [deviceId]: schedule });
    },


    //
    //  Theme Actions
    //
    [ThemeActions.SCHEDULE_THEME_SUCCESS]: (state: State, action: ReturnType<typeof scheduleThemeSuccess>) => {
        const schedules = action.payload;
        return addSchedules(state, schedules);
    },


    //
    //  Building Actions
    //
    [BuildingActions.GET_BUILDING_SUCCESS]: (state: State, action: ReturnType<typeof getBuildingSuccess>) => {
        const { schedules } = action.payload;
        return addSchedules(state, schedules);
    },
} as any, initialState);
